export enum AffiliateMembershipStepsEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    LocationOfPractice = 'Location of practice',
    Membership = 'Membership'
}